import { Controller } from "@hotwired/stimulus";

export default class ComputeTimetableFormController extends Controller {
  static values = {
    computePath: String,
  };

  static targets = ["form"];

  connect () {
    this.computeTimeout = null;
  }

  delayedCompute() {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.compute();
    }, 400);
  }

  compute() {
    fetch(this.computePathValue, {
      method: "PATCH",
      body: new FormData(this.formTarget),
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
        "accept": "application/json",
      },
    })
    .then(response => response.json())
    .then(data => {
      data.project_terms.forEach((term, index) => this._assignTermAttributes(term, index));
    })
  }

  _assignTermAttributes(term, termIndex) {
    const wrapper = this.formTarget.querySelectorAll('.nested-fields-wrapper')[termIndex];

    if (!wrapper) return;

    Object.entries(term).forEach(([key, value]) => {
      const input = wrapper.querySelector(`input[name*="[${key}]"]`)
      if (input) {
        input.value = value
      }
    });
  }
}
